import React from 'react'
import { DescriptionRoot } from './Description.styles'
import { Text } from 'components/Text'

type DescriptionProps = {
  productDescription: string
}

export const Description = ({ productDescription }: DescriptionProps) => {
  return (
    <DescriptionRoot>
      <Text size="headline" color="primary-800">
        {productDescription}
      </Text>
    </DescriptionRoot>
  )
}

Description.displayName = 'Description'
